// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"752ca0d9","423":"f94867cf","496":"d839a279"}[chunkId] + ".chunk.js";
};